/**
 * The "Najbolje iz …" rails on a signed-in home page, derived from the
 * /courses/all/ payload that page has already fetched.
 *
 * Lives here rather than inside a page because two pages draw the same rails:
 * SubscriberHome, and the free-account landing, which shows a free reader the
 * same shelves a subscriber sees.
 */

// Enough to fill the rail and a few swipes past it; the whole catalogue in one
// row would mount 80 cards for Biznis alone.
export const RAIL_SIZE = 20;

const inCategory = (course, slug) =>
	(course?.categories ?? []).some((category) => category?.slug === slug);

// "Najbolje" has to come from something the catalogue actually carries: there
// is no rating on the list payload, so likes are the ranking signal.
const bestFirst = (courses) =>
	[...courses]
		.sort((a, b) => (b?.like_count ?? 0) - (a?.like_count ?? 0))
		.slice(0, RAIL_SIZE);

export function deriveCategoryRails(courses) {
	const list = courses ?? [];

	return {
		biznis: bestFirst(list.filter((course) => inCategory(course, "biznis"))),
		tehnologija: bestFirst(
			list.filter((course) => inCategory(course, "tehnologija"))
		),
		kreativa: bestFirst(
			list.filter((course) => inCategory(course, "kreativa"))
		),
		audio: bestFirst(list.filter((course) => course?.is_audio)),
	};
}
